import { service } from '@ember/service';
import ApplicationAdapter from './application';
import { addRequestLocaleToPagePayload } from 'admin-panel/utils/page-response-locale';
import config from 'admin-panel/config/environment';

import type SessionInfoService from 'admin-panel/services/session-info';

const {
  api: { namespace },
} = config;

export default class PageAdapter extends ApplicationAdapter {
  // Keep page detail loads isolated; one broken page makes coalesced /pages?ids[]=... fail the whole folder.
  coalesceFindRequests = false;

  @service
  declare sessionInfo: SessionInfoService;

  buildURL(...args: Parameters<ApplicationAdapter['buildURL']>) {
    const url = super.buildURL(...args);

    return url.replace(
      `/${namespace}/`,
      `/${namespace}/${this.sessionInfo.contentLocale.key}/`
    );
  }

  handleResponse(...args: Parameters<ApplicationAdapter['handleResponse']>) {
    const payload = args[2] as
      | Parameters<typeof addRequestLocaleToPagePayload>[0]
      | undefined;
    const requestData = args[3] as { url?: string } | undefined;

    addRequestLocaleToPagePayload(payload, requestData?.url);

    return super.handleResponse(...args);
  }
}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    page: PageAdapter;
  }
}
